import type { Practitioner } from '../common'

import { useQuery } from '@tanstack/react-query'

import http from '../../../lib/http'

export type ParticipantsQueryKey = [
  'chats/participants',
  {
    userId?: string
    chatId?: string
  }
]

export type UseChatParticipantsQueryOptions = ParticipantsQueryKey[1]


export function useChatParticipantsQuery ({ userId, chatId }: UseChatParticipantsQueryOptions) {
  return useQuery<Practitioner[], unknown, Practitioner[], ParticipantsQueryKey>({
    queryKey: getChatParticipantsQueryKey({ userId, chatId }),

    async queryFn ({ queryKey, signal }) {
      let [ , { chatId }] = queryKey
      return await http.getRequest(`/chats/${chatId as string}/participants`, {}, { signal })
    },

    enabled: typeof userId === 'string' && typeof chatId === 'string'
  })
}

export function getChatParticipantsQueryKey (options: UseChatParticipantsQueryOptions): ParticipantsQueryKey {
  return [
    'chats/participants',
    { ...options }
  ]
}
